var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDotsThreeVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16C19.5 16.6922 19.2947 17.3689 18.9101 17.9445C18.5256 18.5201 17.9789 18.9687 17.3394 19.2336C16.6999 19.4985 15.9961 19.5678 15.3172 19.4328C14.6383 19.2977 14.0146 18.9644 13.5251 18.4749C13.0356 17.9854 12.7023 17.3618 12.5673 16.6828C12.4322 16.0039 12.5015 15.3002 12.7664 14.6606C13.0313 14.0211 13.4799 13.4744 14.0555 13.0899C14.6311 12.7053 15.3078 12.5 16 12.5C16.928 12.5009 17.8177 12.87 18.4739 13.5261C19.13 14.1823 19.4991 15.072 19.5 16ZM16 9.5C16.6922 9.5 17.3689 9.29473 17.9445 8.91015C18.5201 8.52556 18.9687 7.97894 19.2336 7.33939C19.4985 6.69985 19.5678 5.99612 19.4328 5.31719C19.2977 4.63825 18.9644 4.01461 18.4749 3.52513C17.9854 3.03564 17.3618 2.7023 16.6828 2.56725C16.0039 2.4322 15.3002 2.50152 14.6606 2.76642C14.0211 3.03133 13.4744 3.47993 13.0899 4.05551C12.7053 4.63108 12.5 5.30777 12.5 6C12.5009 6.92798 12.87 7.81768 13.5261 8.47386C14.1823 9.13004 15.072 9.49908 16 9.5ZM16 22.5C15.3078 22.5 14.6311 22.7053 14.0555 23.0899C13.4799 23.4744 13.0313 24.0211 12.7664 24.6606C12.5015 25.3002 12.4322 26.0039 12.5673 26.6828C12.7023 27.3618 13.0356 27.9854 13.5251 28.4749C14.0146 28.9644 14.6383 29.2977 15.3172 29.4328C15.9961 29.5678 16.6999 29.4985 17.3394 29.2336C17.9789 28.9687 18.5256 28.5201 18.9101 27.9445C19.2947 27.3689 19.5 26.6922 19.5 26C19.4991 25.072 19.13 24.1823 18.4739 23.5261C17.8177 22.87 16.928 22.5009 16 22.5Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThreeVertical);
export default __webpack_public_path__ + "static/media/dots-three-vertical.dfcbe54d.svg";
export { ForwardRef as ReactComponent };